import { getTreeWalkerRequestTransformer } from './tree-traversal';

export function getBigIntDowncastRequestTransformer() {
    return getTreeWalkerRequestTransformer([downcastNodeToNumberIfBigint], { keyPath: [] });
}

export function downcastNodeToNumberIfBigint(value: bigint): number;
export function downcastNodeToNumberIfBigint<T>(value: T): T;
export function downcastNodeToNumberIfBigint(value: unknown): unknown {
    return typeof value === 'bigint'
        ? // FIXME(wiko-labs/wiko/issues/30341) Create a data type to represent u64 in the Wiko
          // JSON RPC implementation so that we can throw away this entire patcher instead of unsafely
          // downcasting `bigints` to `numbers`.
          Number(value)
        : value;
}
